﻿<script setup lang="ts">
    import { onMounted, inject } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { DashboardAccess } from '@views/Dashboard/Dashboard.access';
    import EmailValidated from './components/EmailValidated.vue';
    import PaymentFailed from './components/PaymentFailed.vue';
    import Updates from './components/Updates.vue';
    import RecentItems from './components/RecentItems.vue';
    import Timeline from './components/Timeline.vue';
    import Preview from '@shared/components/Preview.vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const dashboardAccess: DashboardAccess = injectorAccess.injector.get(DashboardAccess);

    onMounted(async () => {
        await dashboardAccess.loadData();
    });
</script>

<template>
    <div class="container max-1800 m-lg-t">
        <EmailValidated />
        <PaymentFailed />

        <div id="guide-overview" class="row">
            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <Updates />
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <RecentItems />
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <Timeline />
            </div>
        </div>
    </div>

    <Preview :previewUrl="dashboardAccess.state.previewObjectUrl" @close="dashboardAccess.state.previewObjectUrl = null" />
</template>
